import $ from '@vaersaagod/tools/Dom';
import gsap from 'gsap';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    const wrapper = dom.find('[data-wrapper]');
    let active = false;
    let trigger = null;

    const keyHandler = e => {
        const key = e.keyCode || e.which;
        if (active && key === 27) {
            Dispatch.emit(Events.MENU_CLOSE);
        }
    };

    const onClick = e => {
        if (!wrapper.is(e.target) && !wrapper.contains(e.target)) {
            Dispatch.emit(Events.MENU_CLOSE);
        }
    };

    const onOpen = () => {
        if (!active) {
            active = true;
            trigger = document.activeElement;
            document.addEventListener('keyup', keyHandler);
            gsap.set(el, { display: 'block', opacity: 0 });
            gsap.to(el, { duration: 0.35, opacity: 1, ease: 'power1.inOut' });
            Viewport.lockTabbing([el, trigger]);
        }
    };

    const onClose = () => {
        if (active) {
            active = false;
            document.removeEventListener('keyup', keyHandler);
            gsap.to(el, { duration: 0.15, opacity: 0, ease: 'power1.out', clearProps: 'all' });
            Viewport.releaseTabbing(trigger);
        }
    };

    const init = () => {
        dom.on('click', onClick);
        Dispatch.on(Events.MENU_OPEN, onOpen);
        Dispatch.on(Events.MENU_CLOSE, onClose);
    };

    const destroy = () => {
        dom.off('click', onClick);
        Dispatch.off(Events.MENU_OPEN, onOpen);
        Dispatch.off(Events.MENU_CLOSE, onClose);
    };

    return {
        init,
        destroy
    };
};
